import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { RaisedButton, TextField, RefreshIndicator } from "material-ui"
import RegistrationLayout from "../../components/registration/RegistrationLayout"
import * as api from "../../api"
import * as utils from "../../helpers/utils"
import HtmlLoader from "../../components/layout/HtmlLoader"
import AccountStore from "../../stores/AccountStore"
import * as  appStateActions from "../../actions/AppStateActions"
import { IAccountManagerFESettings } from "../../models/data/account_manager/AccountManagerFESettings"
import AppStateStore from "../../stores/AppStateStore"
import { BrowserView, MobileView } from "react-device-detect"
import { isMobile } from "react-device-detect"
import { browserHistory } from "react-router"

interface IState {
    allValid: boolean
    userFirstName: string
    userFirstNameErrorText: string
    userLastName: string
    userLastNameErrorText: string
    checkingEmail: boolean
    userEmail: string
    userEmailErrorText: string
    frontEndSettings: IAccountManagerFESettings
}

export default class AccountRegistration extends React.Component<null, IState> {
    constructor(props) {
        super(props)
        this.state = {
            allValid: false,
            userFirstName: "",
            userFirstNameErrorText: "",
            userLastName: "",
            userLastNameErrorText: "",
            checkingEmail: false,
            userEmail: "",
            userEmailErrorText: "",
            frontEndSettings: null
        }
        autobind(this)
    }

    componentWillMount() {
        AppStateStore.on("frontEndSettings_change", this.frontEndSettingsChange)
        appStateActions.getFrontEndSettings()
    }

    componentDidMount() {
        document.title = `Register| ${strings.Findd_Grandd_Central}`
        AccountStore.setMarketingDetails(new URLSearchParams(location.search))
    }

    componentWillUnmount() {
        AppStateStore.removeListener("frontEndSettings_change", this.frontEndSettingsChange)
    }

    frontEndSettingsChange() {
        this.setState({ frontEndSettings: AppStateStore.getFrontEndSettings() })
    }

    checkValidate() {
        let returnVal = true
        if (this.state.userFirstName.trim().length === 0) {
            this.setState({ userFirstNameErrorText: strings.First_Name_cannot_be_empty })
            returnVal = false
        } else {
            this.setState({ userFirstNameErrorText: "" })
        }

        if (this.state.userLastName.trim().length === 0) {
            this.setState({ userLastNameErrorText: "Last name cannot be empty." })
            returnVal = false
        } else {
            this.setState({ userLastNameErrorText: "" })
        }

        if (utils.validateEmail(this.state.userEmail)) {
            this.setState({ userEmailErrorText: "" })
        }
        else {
            this.setState({ userEmailErrorText: strings.Invalid_email_format })
            returnVal = false
        }
        this.setState({ allValid: returnVal })
        return returnVal
    }

    saveAccount() {
        if (!this.checkValidate()) return

        this.setState({ checkingEmail: true }, () => {
            api.emailExists(this.state.userEmail).then(result => {
                this.setState({ userEmailErrorText: result.data ? "Email already exists" : null }, () => {
                    result.data ?
                        this.setState({ userEmailErrorText: "This email is already associated with an account. Please choose a different email.", checkingEmail: false }) :
                        this.setState({ checkingEmail: false }, () => {
                            AppStateStore.registrationUserFirstName = this.state.userFirstName.trim()
                            AppStateStore.registrationUserLastName = this.state.userLastName.trim()
                            AppStateStore.registrationEmail = this.state.userEmail.trim()
                            browserHistory.replace("account_registration_info")
                        })
                })
            })
        })
    }

    render() {
        if (this.state.frontEndSettings === null) {
            return (
                <div style={{ textAlign: "center", position: "absolute", top: "50%", left: "50%" }}><div style={{ padding: 20 }}>{strings.loading}</div></div>
            )
        }

        return (
            <RegistrationLayout
                leftContainer={
                    <div>
                        <MobileView>
                            <h3>Create your free account</h3>
                        </MobileView>
                        <BrowserView>
                            <h1>Create your free account</h1>
                        </BrowserView>
                        <div style={{ display: isMobile ? null : "flex", flexDirection: isMobile ? null : "row", backroundColor: "red" }}>
                            <TextField
                                floatingLabelText={strings.First_Name}
                                value={this.state.userFirstName}
                                onChange={(e, value) => this.setState({ userFirstName: value }, () => this.checkValidate())}
                                errorText={this.state.userFirstNameErrorText}
                                style={{ marginRight: isMobile ? null : 20, width: isMobile ? "100%" : "50%" }}
                                autoFocus
                            />
                            <TextField
                                floatingLabelText={strings.Last_Name}
                                value={this.state.userLastName}
                                onChange={(e, value) => this.setState({ userLastName: value }, () => this.checkValidate())}
                                errorText={this.state.userLastNameErrorText}
                                style={{ width: isMobile ? "100%" : "50%" }}
                            />
                        </div>
                        <div>
                            <TextField
                                floatingLabelText={strings.Email}
                                value={this.state.userEmail}
                                onChange={(e, value) => this.setState({ userEmail: value }, () => this.checkValidate())}
                                errorText={this.state.userEmailErrorText}
                                style={{ marginRight: 20, width: "100%" }}
                            />
                        </div>

                        {this.state.checkingEmail ?
                            <div style={{ marginTop: 50, textAlign: "center" }}>
                                <RefreshIndicator
                                    size={35}
                                    status="loading"
                                    style={{ position: "static", display: "block", margin: "0 auto" }}
                                />
                            </div> :
                            <div style={{ marginTop: 50 }}>
                                <RaisedButton
                                    data-intercom-target={"AccountManagerDrawer-Btn-save"}
                                    disabled={!this.state.allValid}
                                    backgroundColor="#1181F2"
                                    labelColor="white"
                                    label={strings.Next}
                                    onTouchTap={() => this.saveAccount()}
                                    style={{ width: "100%" }}
                                />
                            </div>
                        }
                        <div style={{ textAlign: "center" }}>
                            <div style={{ marginTop: 20, color: "rgba(0,0,0,0.4)" }}>
                                <p>— OR —</p>
                            </div>
                            <div style={{ marginTop: 20 }}>
                                <a href="/login" style={{ color: "rgba(0,0,0,0.4)" }}>Go To Login</a>
                            </div>
                        </div>
                    </div>
                }
                rightContainer={
                    <div style={{ color: "white", padding: 50 }}>
                        <HtmlLoader htmlUrl="https://findd-prod-assets.s3.us-west-2.amazonaws.com/web/account_registration.html" />
                    </div>
                }
                loading={null}
                frontEndSettings={this.state.frontEndSettings}
            />
        )
    }
}